<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cash-multiple"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $tc('consolidated_invoices') }}
        </div>
      </template>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.last_executed_at="{ item }">
          {{ convertUTCToLocal(item.last_executed_at)}}
        </template>
        <template v-slot:item.next_execution_at="{ item }">
          {{ convertUTCToLocal(item.next_execution_at)}}
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.status == 'terminated'" class="roundedfull red">
          </div>
          <div v-if="item.status == 'running'" class="roundedfull yellow">
          </div>
          <div v-if="item.status == 'ready'" class="roundedfull green">
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div style="display: flex;">
            <div @click="showOverlay(item.id)" style="position: relative;" class="iconbox">
              <v-icon
                color="blue darken-2"
                style="margin-right: 10px; cursor: pointer;"
                size="20"
                v-text="'mdi-format-list-group'"
              />
              <div class="buble">
                <p>Se pallenumre</p>
              </div>
            </div>
            <div @click="editItem(item.customer_id)" style="position: relative;" class="iconbox">
              <v-icon
                style="margin-right: 10px; cursor: pointer;"
                color="green darken-2"
                size="20"
                v-text="'mdi-pencil-outline'"
              />
              <div class="buble">
                <p>Opdater procedure</p>
              </div>
            </div>
            <div @click="runProcedure(item.id)" style="position: relative;" class="iconbox">
              <v-icon
                style="cursor: pointer;"
                v-if="item.status == 'ready'"
                color="orange darken-2"
                size="20"
                v-text="'mdi-arrow-right-bold'"
              />
              <div class="buble">
                <p>Gennemtving procedure</p>
              </div>
            </div>
          </div>
        </template>
      </v-data-table>
    </base-material-card>
    <v-overlay
      :value="overlay"
    >
      <div class="dialogbox">
        <p style="color: black; text-align: center; padding-top: 30px; font-size: 25px;">Palle og pakkenumre</p>
        <div class="text-center">
          <v-progress-circular
            v-if="palletsLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div>
          <v-row no-gutters>
            <v-col>
              <p style="color: black;">Pallenumre</p>
              <div v-if="pallets.length !== 0 && !palletsLoading">
                <p style="color: black;" v-for="palletnumber in pallets" :key="palletnumber">
                  {{palletnumber}}
                </p>
              </div>
              <p v-if="pallets.length == 0 && !palletsLoading" style="color: black;">
                Der er ingen paller på denne samlefaktura
              </p>
            </v-col>
            <v-col>
              <p style="color: black;">Pakkenumre</p>
              <div v-if="package_numbers.length !== 0 && !palletsLoading">
                <p style="color: black;" v-for="packagenumber in package_numbers" :key="packagenumber">
                  {{packagenumber}}
                </p>
              </div>
              <p v-if="package_numbers.length == 0 && !palletsLoading" style="color: black;">
                Der er ingen pakkenumre på denne samlefaktura
              </p>
            </v-col>
          </v-row>
        </div>
        <v-btn
        class="white--text"
        color="teal"
        @click="overlay = false"
        absolute
        bottom
        right
        >
        Luk
      </v-btn>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import List from '@/mixins/List'
export default {
  name: 'Consolidated Invoices',
   mixins: [List],
    data () {
      return {
        overlay: false,
        endpoint: 'consolidatedinvoices/procedures',
        palletsLoading: false,
        pallets: [],
        package_numbers: [],
        headers: [
          {
            sortable: false,
            text: this.$t('company'),
            value: 'customer_name',
          },
          {
            sortable: false,
            text: this.$t('last_executed_at_pallets'),
            value: 'last_executed_at',
          },
          {
            sortable: false,
            text: this.$t('next_execution_at'),
            value: 'next_execution_at',
          },
          {
            sortable: false,
            text: this.$t('pallets_count'),
            value: 'pallets_count',
          },
          {
            sortable: false,
            text: this.$t('shipments_count'),
            value: 'shipments_count',
          },
          {
            sortable: false,
            text: this.$t('status'),
            value: 'status',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          }
        ],
      }
    },
    methods: {
      editItem: function (id) {
        this.$router.push(`/customers/${id}/procedures`)
      },
      runProcedure: function (id) {
        this.$get(`/consolidatedinvoices/procedures/${id}/run`)
          .then(res => {
            this.$toast(res.data.message)
          })
          .catch(e => {
          })
      },
      showOverlay: function(id) {
        this.pallets = []
        this.package_numbers = []
        this.overlay = true
        this.palletsLoading = true
        this.$get(`/consolidatedinvoices/procedures/${id}`)
          .then(res => {
            this.pallets = res.data.pallets
            this.package_numbers = res.data.package_numbers
          })
          .finally(() => {
            this.palletsLoading = false
          })
      },
    }
}
</script>

<style lang="scss" scoped>
.roundedfull {
  border-radius: 9999px;
  width: 20px;
  height: 20px;
}
.red{
  background-color: red;
}
.yellow{
  background-color: yellow;
}
.green{
  background-color: green;
}
.iconbox:hover .buble {
   opacity: 1;
}
.dialogbox {
  width: 60vw;
  height: 80vh;
  background-color: white;
  border-radius: 5px;
  text-align: center;
  overflow-y: scroll;
}
.buble{
  position: absolute;
  top: -20px;
  left: -30px;
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  height: 25px;
  font-size: 10px;
  font-weight: bold;
  color: black;
  opacity: 0;
  transition: opacity 0.3s;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.5);
  pointer-events: none;
}
</style>
